import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../../core/service/app.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { signal } from '@angular/core';
@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.component.html',
    standalone: true,
    imports: [
    NgClass,
    RouterOutlet
],
})
export class AuthLayout implements OnInit, OnDestroy {
    store = signal<any>(null);
    showTopButton= signal(false);

    constructor(public storeData: Store<any>, private readonly service: AppService) {}
    headerClass = '';
    ngOnInit() {
        this.initStore();
        this.toggleLoader();
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            window.addEventListener('scroll', () => {
                if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                    this.showTopButton.set(true);
                } else {
                    this.showTopButton.set(false);
                }
            });
        }
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    ngOnDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', () => {});
        }
    }

    initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store.set(d);
            });
    }

    goToTop() {
        if (typeof document !== 'undefined') {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    }
}
